import { useOrganization } from 'core/stores/hooks/useOrganization';
import { Channels } from 'generated-graphql/types';
import { channelsAvailable } from 'modules/campaign-creation/constants/channelsAvailable';
import { CampaignCreationCSVColumns } from 'modules/campaign-creation/components/CampaignCreationCSVUpload';
import { checkChannelCSVIsDisabled } from 'modules/campaign-creation/utils/checkChannelCSVIsDisabled';

const channelLabelByChannelValue = {
  [Channels.Whatsapp]: 'WhatsApp',
  [Channels.Sms]: 'SMS',
  [Channels.Email]: 'Email'
};

type AvailableChannel = {
  value: Channels;
  label: string;
  disabled: boolean;
};

type UseAvailableChannelsProps = {
  csvColumns: CampaignCreationCSVColumns | null;
  hideWhatsApp?: boolean;
};

type UseAvailableChannelsResponse = {
  allChannels: AvailableChannel[];
  availableChannels: AvailableChannel[];
};

export const useAvailableChannels = ({
  csvColumns,
  hideWhatsApp = false
}: UseAvailableChannelsProps): UseAvailableChannelsResponse => {
  const organization = useOrganization();
  const channelsEnabled = organization?.channelsEnabled;

  const channels: AvailableChannel[] = channelsAvailable
    .filter((channel) => channelsEnabled?.includes(channel))
    .filter((channel) => !hideWhatsApp || channel !== Channels.Whatsapp)
    .map((channel) => ({
      value: channel,
      label:
        channelLabelByChannelValue[
          channel as keyof typeof channelLabelByChannelValue
        ],
      disabled: checkChannelCSVIsDisabled({
        channel,
        csvColumns
      })
    }));

  return {
    allChannels: channels,
    availableChannels: channels.filter((channel) => !channel.disabled)
  };
};
